import React from "react";
import { Link } from "react-router-dom";

import star from "../../assets/images/star.png";
import classes from "./SeriesItem.module.css";

import { TvShow } from "src/types/tvSeriesData";
import { omitWhiteSpace } from "src/utility";

type Props = {
  showsData: TvShow;
};
const SeriesItem = ({ showsData }: Props) => {
  //Removing space between show name
  const showName = omitWhiteSpace(showsData.name);

  return (
    <div className={classes.movieItem}>
      <div className={classes.ratingBadge}>
        <span className={classes.rating}>
          {Math.round(showsData.vote_average)}
        </span>
        <img src={star} alt="rating star" className={classes.star}></img>
      </div>
      <Link to={`showDetail/${showsData.id}/${showName}`}>
        <img
          src={`https://image.tmdb.org/t/p/w500/${showsData.poster_path}`}
          alt={showsData.name}
          width={234}
          height={330}
          className={classes.poster}
        />
      </Link>
      <div className={classes.movieInfo}>
        <Link
          to={`showDetail/${showsData.id}/${showName}`}
          className={classes.title}
        >
          {showsData.name}
        </Link>
      </div>
    </div>
  );
};

export default SeriesItem;
